export default __webpack_public_path__ + "static/media/ninjauser.d4d9e018.svg";